import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyAppInstallationKey,
  ShopifyAppInstallationToAppKey,
  ShopifyAppInstallationToShopKey,
  ShopifyAppKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyAppInstallationKey,
  "2022-01": {
    name: "Shopify App Installation",
    graphQLTypename: "AppInstallation",
    fields: [
      {
        name: "App",
        fieldType: FieldType.BelongsTo,
        key: ShopifyAppInstallationToAppKey,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "app" } },
        configuration: {
          relatedModelKey: ShopifyAppKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyAppInstallationToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
      // {
      //   name: "Publication",
      //   fieldType: FieldType.BelongsTo,
      //   key: ShopifyAppInstallationToPublicationKey,
      //   configuration: {
      //     relatedModelKey: ShopifyPublicationKey,
      //   },
      // },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "id" } },
      },
      {
        name: "Access Scopes",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "accessScopes" } },
      },
      {
        name: "Launch URL",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "launchUrl" } },
      },
      {
        name: "Uninstall URL",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "uninstallUrl" } },
      },
      // {
      //   name: "Active Subscriptions",
      //   fieldType: FieldType.HasMany,
      //   contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "activeSubscriptions" } },
      //   configuration: {
      //     relatedModelKey: ShopifyAppSubscriptionKey,
      //     inverseFieldKey: ShopifyAppSubscriptionToAppInstallationKey,
      //   },
      // },
    ],
    syncConfig: { type: "custom", resource: "appInstallation" },
  },
  "2022-07": {
    name: "Shopify App Installation",
    hasMetafields: true,
  },
};

export const ShopifyAppInstallation = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
